import axios from '../../axiosInstance';
import requests from '../../requests';
import { canvasActionTypes } from './canvas.types';

// FETCH DIAGRAM MEMBERS
// --------------------------------------------------------------
export const fetchDiagramMembers = (diagramId) => ({
    type: canvasActionTypes.FETCH_DIAGRAM_MEMBERS_REQUEST,
    payload: { diagramId },
})
export const fetchDiagramMembersSuccess = (data) => ({
    type: canvasActionTypes.FETCH_DIAGRAM_MEMBERS_SUCCESS,
    payload: { data },
})
export const fetchDiagramMembersFailure = error => ({
    type: canvasActionTypes.FETCH_DIAGRAM_MEMBERS_FAILURE,
    payload: error,
})

// CHANGE ROLE FOR DIAGRAM MEMBER
// --------------------------------------------------------------
export const changeRoleForDiagramMember = (diagramId, memberId, newRole) => ({
    type: canvasActionTypes.CHANGE_MEMBER_ROLE_REQUEST,
    payload: { diagramId, memberId, newRole },
})
export const changeRoleForDiagramMemberSuccess = (data) => ({
    type: canvasActionTypes.CHANGE_MEMBER_ROLE_SUCCESS,
    payload: { data },
})
export const changeRoleForDiagramMemberFailure = error => ({
    type: canvasActionTypes.CHANGE_MEMBER_ROLE_FAILURE,
    payload: error,
})

// REMOVE DIAGRAM MEMBER
// --------------------------------------------------------------
export const removeDiagramMember = (diagramId, memberId) => ({
    type: canvasActionTypes.REMOVE_DIAGRAM_MEMBER_REQUEST,
    payload: { diagramId, memberId },
})
export const removeDiagramMemberSuccess = (data) => ({
    type: canvasActionTypes.REMOVE_DIAGRAM_MEMBER_SUCCESS,
    payload: { data },
})
export const removeDiagramMemberFailure = error => ({
    type: canvasActionTypes.REMOVE_DIAGRAM_MEMBER_FAILURE,
    payload: error,
})

// FETCH DIAGRAM INVITES
// --------------------------------------------------------------
export const fetchDiagramInvites = (diagramId) => ({
    type: canvasActionTypes.FETCH_DIAGRAM_INVITES_REQUEST,
    payload: { diagramId },
})
export const fetchDiagramInvitesSuccess = (data) => ({
    type: canvasActionTypes.FETCH_DIAGRAM_INVITES_SUCCESS,
    payload: { data },
})
export const fetchDiagramInvitesFailure = error => ({
    type: canvasActionTypes.FETCH_DIAGRAM_INVITES_FAILURE,
    payload: error,
})

// CREATE DIAGRAM INVITE
// --------------------------------------------------------------
export const createDiagramInvite = (diagramId, email, role) => ({
    type: canvasActionTypes.CREATE_DIAGRAM_INVITE_REQUEST,
    payload: { diagramId, email, role },
})
export const createDiagramInviteSuccess = (data) => ({
    type: canvasActionTypes.CREATE_DIAGRAM_INVITE_SUCCESS,
    payload: { data },
})
export const createDiagramInviteFailure = error => ({
    type: canvasActionTypes.CREATE_DIAGRAM_INVITE_FAILURE,
    payload: error,
})


// REVOKE DIAGRAM INVITE
// --------------------------------------------------------------
export const revokeDiagramInvite = (diagramId, inviteId) => ({
    type: canvasActionTypes.REVOKE_DIAGRAM_INVITE_REQUEST,
    payload: { diagramId, inviteId },
})
export const revokeDiagramInviteSuccess = (data) => ({
    type: canvasActionTypes.REVOKE_DIAGRAM_INVITE_SUCCESS,
    payload: { data },
})
export const revokeDiagramInviteFailure = error => ({
    type: canvasActionTypes.REVOKE_DIAGRAM_INVITE_FAILURE,
    payload: error,
})
